import { createApp, nextTick } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import App from './App.vue'
import router from './router'
import { i18n } from './i18n'
import { useAuthStore } from './stores/auth'
import { useThemeStore } from './stores/theme'
import { useLocaleUiStore } from './stores/locale-ui'
import { useTenantBrandingStore } from './stores/tenant-branding'
import './registerServiceWorker'
import './assets/styles/main.css'

async function bootstrap() {
  const app = createApp(App)
  const pinia = createPinia()
  pinia.use(piniaPluginPersistedstate)

  app.use(pinia)
  app.use(i18n)
  await nextTick()
  app.use(router)

  useLocaleUiStore().syncI18n()
  const themeStore = useThemeStore()
  themeStore.startWatcher()
  themeStore.applyTheme()

  const authStore = useAuthStore()
  await authStore.initializeFromStorage()

  await useTenantBrandingStore().load()

  // Re-apply after branding mutates document; keeps `dark` on html in sync with persisted theme.
  themeStore.applyTheme()

  await router.isReady()

  app.mount('#app')
}

bootstrap()
